import defaultRequestErrorHandler from 'src/api/notifications/defaultRequestErrorHandler';
import { AddNotification } from 'src/components/Notifications/Provider/types';
import { ContextVacancy } from 'src/models/resumeSearchContext';
import { fetcher } from 'src/utils/fetcher';

const SEARCH_ACTIVE_VACANCIES_URL = '/shards/search/resume/context_vacancy/active_vacancies';

interface ResponseData {
    managerActiveVacancies: Array<ContextVacancy>;
}

declare global {
    interface FetcherGetApi {
        [SEARCH_ACTIVE_VACANCIES_URL]: {
            queryParams: {
                query: string;
            };
            response: ResponseData;
        };
    }
}

export const searchActiveVacancies = async (
    query: string,
    addNotification: AddNotification
): Promise<Array<ContextVacancy>> => {
    let data: ResponseData = { managerActiveVacancies: [] };
    try {
        data = await fetcher.get(SEARCH_ACTIVE_VACANCIES_URL, { params: { query } });
        return data?.managerActiveVacancies || [];
    } catch (e) {
        defaultRequestErrorHandler(e, addNotification);
    }
    return [];
};
